module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_decollte-5fa8bad39092f02b8ebd7dc7fa2c7292.svg";